import { importAll } from "../utils";

const merged = importAll(require.context(".", true, /\.json$/));

export default merged;
